export const NOTIFICATION_STRINGS = {
  // Existing Check-in Messages
  HALF_HOUR_CHECK_IN_MESSAGE:
    "Final warning to confirm attendance or you will risk being eliminated from this event and lose your wager and face sanctions from the platform.",
  ONE_HOUR_CHECK_IN_MESSAGE:
    "This is your last warning to confirm attendance or you will risk being eliminated from this event and lose your wager and face sanctions from the platform.",
  TWO_HOURS_CHECK_IN_MESSAGE:
    "The event is just 3 hours away. Don’t miss out—be ready to confirm your spot and participate. Check-in will close in 2 hours.",
  THREE_HOURS_CHECK_IN_MESSAGE:
    "The event is just 4 hours away. Don’t miss out—be ready to confirm your spot and participate. Check-in will close in 3 hours.",
  FIVE_HOURS_CHECK_IN_MESSAGE:
    "The event is just 6 hours away! Check-in has started. Don’t miss out—be ready to confirm your spot and participate. Check-in will close in 5 hours.",
  SIX_HOURS_CHECK_IN_MESSAGE:
    "The event is just 7 hours away! Check-in has started. Don’t miss out—be ready to confirm your spot and participate. Check-in will close in 6 hours.",
  TWELVE_HOURS_CHECK_IN_MESSAGE:
    "The event is just 13 hours away! Check-in has started. Don’t miss out—be ready to confirm your spot and participate. Check-in will close in 12 hours.",
  TWENTY_FOUR_HOURS_CHECK_IN_MESSAGE:
    "Your event is happening tomorrow! Get ready to participate and make sure everything is set up. Check-in will close 1 hour before event start time.",
  DEFAULT_EVENT_REMINDER: "Event Reminder : ",

  // Existing Check-in Headers
  HALF_HOUR_CHECK_IN_HEADER: "Final warning!",
  ONE_HOUR_CHECK_IN_HEADER: "Final Call: Check-In Now!",
  TWO_HOURS_CHECK_IN_HEADER: "Last warning to confirm your seat.",
  THREE_HOURS_CHECK_IN_HEADER: "Hurry up for event ",
  FIVE_HOURS_CHECK_IN_HEADER: "Check-In Opens Soon for event ",
  TWENTY_FOUR_HOURS_CHECK_IN_HEADER: "Event Check-in Reminder for ",
  DEFAULT_CHECK_IN_HEADER: "Event Check-in Reminder for ",

  // Existing Event Reminder Texts
  EVENT_REMINDER_WILL_BEGIN_IN: "will begin in",
  EVENT_REMINDER_WILL_BEGIN_SOON: "will begin soon",
  EVENT_REMINDER_AN_HOUR: " an hour",
  EVENT_REMINDER_TWO_HOURS: " 2 hours",
  EVENT_REMINDER_THREE_HOURS: " 3 hours",
  EVENT_REMINDER_FOUR_HOURS: " 4 hours",
  EVENT_REMINDER_FIVE_HOURS: " 5 hours",
  EVENT_REMINDER_SIX_HOURS: " 6 hours",
  EVENT_REMINDER_TWELVE_HOURS: " 12 hours",
  EVENT_REMINDER_TWENTY_FOUR_HOURS: " 24 hours",

  // Existing WinnerComponent
  LOOSER: "Looser",
  WINNER: "Winner",
  COIN: "Coin",
  BRONZE: "Bronze",
  SILVER: "Silver",
  GOLD: "Gold",
  PLATINUM: "Platinum",
  ONE_VS_ONE: "1vs1",
  GIFT_CREDITS: "Gift Credits",

  // Existing Other Texts
  YOU_MISSED_YOUR_EVENT: "You Missed Your Event!",
  FAILED_TO_CHECK_IN_ORGANIZER: "You failed to check in for the event : ",
  NO_LONGER_ORGANIZER: " You are no longer Organizer of the Event.",
  NO_LONGER_PARTICIPANT: " You are no longer part of this Event.",
  CHECK_IN_UPDATE_FOR: "Check-In Update for ",
  EVENT: "Event : ",
  FOR: "for ",
  HAS_REJECTED_YOUR_CHALLENGE_IN: "has Rejected your challenge in ",
  HAS_ACCEPTED_YOUR_CHALLENGE_IN: "has Accepted your challenge in ",
  YOU_HAVE_SENT_A_CHALLENGE_TO: "You have sent a challenge to ",
  IN: "in ",
  FOR_EVENT: "for event : ",
  CHECK_OUT_DETAILS_OF_THE_EVENT: "Check Out details of the event : ",
  CHECK_OUT_THE_UPDATED_DETAILS_OF_THE_EVENT:
    "Check Out the updated details of the event",
  YOU_REJECTED_CHANGES_FOR: "You rejected changes for : ",
  YOU_ACCEPTED_CHANGES_FOR: "You accepted changes for : ",
  HAS_SENT_YOU_CHALLENGE_IN: "has Sent you challenge in ",
  HAS_BEEN_CANCELLED: "has been cancelled",
  CHECK_OUT_DETAILS_OF_THE_EVENT_IM_WATCHING:
    "Check out details of the event :",
  REMAINING_TIME: "Remaining time: ",
  DAYS: "Days",
  HOURS: "Hours",
  MINUTES: "Minutes",
  SECONDS: "Seconds",
  EVENT_CANCELLED: "Event Cancelled",
  UNKNOWN: "Unknown",

  VIEW_DETAILS: "View Details",
  INVITE_ANOTHER_OPPONENT: "Invite Another Opponent",
  ACCEPT_CHALLENGE: "Accept Challenge",
  CHALLENGE_ACCEPTED: "Challenge Accepted",
  REJECT_CHALLENGE: "Reject Challenge",
  CHALLENGE_REJECTED: "Challenge Rejected",
  OPEN_EVENT_PAGE: "Open Event Page",
  CONFIRM: "Confirm",
  CONFIRMED: "Confirmed",
  VIEW_EVENT_DETAILS: "View Event Details",

  ATTENDANCE_CONFIRMED_TITLE: "Attendance Confirmed",
  ATTENDANCE_CONFIRMED_MESSAGE:
    "You have successfully confirmed your attendance for",
  ATTENDANCE_CONFIRMED: "Attendance Confirmed",

  ATTENDANCE_REMINDER_24H_TITLE: "Your Event is Tomorrow – Get Ready!",
  ATTENDANCE_REMINDER_24H_MESSAGE:
    "Your match is scheduled for tomorrow. Make sure your setup is ready. Confirm your attendance within 24 hours.",
  ATTENDANCE_REMINDER_12H_TITLE: "Heads Up - Your Match is in 12 Hours!",
  ATTENDANCE_REMINDER_12H_MESSAGE:
    "Don’t miss out! Confirm your attendance now to avoid penalties or cancellation.",
  ATTENDANCE_REMINDER_6H_TITLE: "6 Hours Left - Stay Sharp!",
  ATTENDANCE_REMINDER_6H_MESSAGE:
    "Don’t lose your place! Confirm your attendance before the event starts.",
  ATTENDANCE_REMINDER_3H_TITLE: "3 Hours to Go",
  ATTENDANCE_REMINDER_3H_MESSAGE:
    "It’s almost game time! Confirm your attendance now to keep your spot. Don’t risk losing your wager.",
  ATTENDANCE_REMINDER_1H_TITLE: "Final Warning: Attendance Not Confirmed",
  ATTENDANCE_REMINDER_1H_MESSAGE:
    "Quick reminder — confirm in the next 30 minutes or you’ll be removed and lose your wager.",
  ATTENDANCE_REMINDER_FINAL_WARNING_TITLE:
    "Final Warning: Check-In Not Completed",
  ATTENDANCE_REMINDER_FINAL_WARNING_MESSAGE:
    "You must check-in within 30 minutes or you’ll be removed and lose your wager.",
  ATTENDANCE_MISSED_TITLE: "You Missed Your Event",
  ATTENDANCE_MISSED_MESSAGE:
    "You didn’t confirm, so you’ve been removed from the event. Your wager is lost and the win goes to your opponent.",
  OPPONENT_ALERT_TITLE: "Your Opponent Hasn’t Confirmed Yet",
  OPPONENT_ALERT_MESSAGE:
    "We’re still waiting on your opponent to confirm attendance. Feel free to reach out and remind them.",
  AUDIENCE_ALERT_PENDING_TITLE: "Event Status: Pending Confirmation",
  AUDIENCE_ALERT_PENDING_MESSAGE:
    "One of the players hasn’t confirmed attendance yet. There’s a chance this event may be canceled.",
  AUDIENCE_ALERT_CANCELED_TITLE: "Event canceled due to No-Show",
  AUDIENCE_ALERT_CANCELED_MESSAGE:
    "Unfortunately, one of the players failed to confirm attendance. The event has been canceled.",
  EVENT_AWARDED_TITLE: "You've Been Awarded the Win!",
  EVENT_AWARDED_MESSAGE:
    "Your opponent did not confirm attendance and missed the event. The match has been cancelled. You're marked as the winner and received 50% of their wager credits.",
  EVENT_WON_TITLE: "Congratulations! You Won!",
  EVENT_WON_MESSAGE:
    "The event has completed. Congratulations on your victory! You have received your wager credits and gifts.",
  EVENT_LOST_TITLE: "You Lost the Event.",
  EVENT_LOST_MESSAGE:
    "The event has completed. Better luck next time. Your wager is lost.",
  ACCOUNT_WARNING_TITLE: "Warning: One More Miss Could Freeze Your Account",
  ACCOUNT_WARNING_MESSAGE:
    "You’ve already missed an event without confirming attendance. If this happens again, your account may be temporarily frozen.",

  STAKES: "Stakes",
};
